<div class="control-container" [ngClass]="[containerCss, attrDisable ? 'disabled' : '']">
  <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  <div
    class="control-content align-items-center"
    [ngClass]="[
      markAsInvalid || (errors && showValidationError) ? 'invalid' : '',
      attrDisable ? 'disabled' : '',
      !attrDisable ? 'active' : ''
    ]"
  >
    <div class="color-block" [ngStyle]="{ background: control.value }">{{ control.value }}</div>
    <div class="color-picker-wrapper">
      <color-chrome class="color-picker" [formControl]="control" [color]="control.value"></color-chrome>
    </div>
  </div>

  <app-input-error
    *ngIf="errorSection && errors"
    [errors]="errors"
    [visible]="markAsInvalid || (errors && showValidationError)"
  ></app-input-error>
</div>

<ng-template #labelTemplate>
  <div #labelElement class="display-flex align-items-center grid-gap-4" *ngIf="label || icon">
    <label [ngClass]="[labelCss, attrDisable ? 'disable' : '']" *ngIf="label">{{ label }}</label>
    <app-icon
      [ngClass]="iconCss"
      [matTooltip]="iconTooltip"
      *ngIf="icon"
      [svg]="icon"
      [iconHeight]="24"
      [iconWidth]="24"
    ></app-icon>
  </div>
</ng-template>
